import { render, staticRenderFns } from "./BtnMovimientos.vue?vue&type=template&id=37962359&"
import script from "./BtnMovimientos.vue?vue&type=script&lang=js&"
export * from "./BtnMovimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports